import { render, staticRenderFns } from "./expectedAmount.vue?vue&type=template&id=fc70d7da&scoped=true&"
import script from "./expectedAmount.vue?vue&type=script&lang=js&"
export * from "./expectedAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc70d7da",
  null
  
)

export default component.exports